(function () {
  var PURCHASES = [
    { name: 'Kieran', city: 'Durham', product: 'Baby Pink' },
    { name: 'Dylan', city: 'Accrington', product: 'Baby Pink' },
    { name: 'Joey', city: 'Great Aycliffe', product: 'Baby Pink' },
    { name: 'Billiejo', city: 'Sunderland', product: 'Baby Pink' },
    { name: 'Gemma', city: 'Peterlee', product: 'Baby Pink' },
    { name: 'Harrison', city: 'Hartlepool', product: 'Baby Pink' },
    { name: 'Max', city: 'South Shields', product: 'Baby Pink' },
    { name: 'David', city: 'Houghton le Spring', product: 'Baby Pink' },
    { name: 'Bradley', city: 'Middlesbrough', product: 'Baby Pink' },
    { name: 'Cole', city: 'Ferryhill', product: 'Baby Pink' },
    { name: 'Felicity', city: 'Berwick-Upon-Tweed', product: 'Baby Pink' },
    { name: 'Oliver', city: 'Hull', product: 'Baby Pink' },
    { name: 'Owen', city: 'Newcastle upon Tyne', product: 'Baby Pink' },
    { name: 'Mason', city: 'Sunderland', product: 'Baby Pink' },
    { name: 'Sonny', city: 'Gateshead', product: 'Baby Pink' },
    { name: 'Sophie', city: 'Houghton le Spring', product: 'Baby Pink' },
    { name: 'Ryan', city: 'Middlesbrough', product: 'Baby Pink' },
    { name: 'Brad', city: 'Blyth', product: 'Baby Pink' },
    { name: 'Finley', city: 'Middlesbrough', product: 'Baby Pink' }
  ];

  var CHECK_SVG = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var FIRST_DELAY = 4000;
  var VISIBLE_DURATION = 5000;
  var GAP_BETWEEN = 7000;

  var toast, iconEl, textEl, closeBtn;
  var dismissedManually = false;
  var index = 0;

  function buildToast() {
    toast = document.createElement('div');
    toast.className = 'nap-rp-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');

    iconEl = document.createElement('div');
    iconEl.className = 'nap-rp-icon';
    iconEl.innerHTML = CHECK_SVG;

    textEl = document.createElement('div');
    textEl.className = 'nap-rp-text';

    closeBtn = document.createElement('button');
    closeBtn.className = 'nap-rp-close';
    closeBtn.setAttribute('aria-label', 'Dismiss');
    closeBtn.textContent = '\u2715';
    closeBtn.addEventListener('click', function () {
      dismissedManually = true;
      hideToast();
    });

    toast.appendChild(iconEl);
    toast.appendChild(textEl);
    toast.appendChild(closeBtn);
    document.body.appendChild(toast);
  }

  function showNext() {
    if (dismissedManually) return;
    var item = PURCHASES[index % PURCHASES.length];
    index++;

    textEl.innerHTML = '<strong>' + item.name + '</strong> from ' + item.city +
      '<span class="nap-rp-sub">Purchased the ' + item.product + ' Trucker</span>';

    toast.classList.add('is-visible');

    setTimeout(hideToast, VISIBLE_DURATION);
  }

  function hideToast() {
    if (!toast) return;
    toast.classList.remove('is-visible');
  }

  function loop() {
    if (dismissedManually) return;
    showNext();
    setTimeout(function () {
      if (dismissedManually) return;
      loop();
    }, VISIBLE_DURATION + GAP_BETWEEN);
  }

  function init() {
    if (document.querySelector('.nap-rp-toast')) return;
    buildToast();
    setTimeout(loop, FIRST_DELAY);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
